import { Workspace } from './types';

export const NO_PARENT_CLIENT_ID = 0;

export const NO_PARENT_WORKSPACE: Workspace = {
  name: 'No parent workspace',
  id: NO_PARENT_CLIENT_ID,
  uuid: `${NO_PARENT_CLIENT_ID}`,
};
